export default {"src":"/_next/static/media/close_black_round.40bbd786.svg","height":46,"width":46};